import SignUpPage from './SignUp';

export default SignUpPage;
